import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getDocument } from "../../services/user/UserServices";
import FilePreview from "../../common/FilePreview";
import { Circles } from "react-loader-spinner";
import { Box } from "@mui/material";
import "./termOfUse.scss";
import DefaultTermOfUse from "./defaultTermOfUse";
const TermOfUse = () => {
  const { t } = useTranslation();
  const [fileData, setFileData] = useState("");
  const [loader, setLoader] = useState(true);
  const auth = localStorage.getItem("auth");
  const uploadedFiles = localStorage.getItem("uploadedFiles");

  const navigateToImprintUrl = (url) => {
    window.location.replace(url);
  };
  const handleViewFile = async () => {
    if (uploadedFiles && uploadedFiles != "null") {
      const { termOfUse } = JSON.parse(uploadedFiles);
      if (termOfUse) {
        let result = await getDocument(termOfUse.url);
        if (result.success) {
          setFileData(result?.payLoad);
        } else {
          console.log("result", result);
        }
      }
    } else {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (auth) handleViewFile();
  }, [auth]);
  return (
    <div>
      {auth ? (
        fileData ? (
          <FilePreview data={fileData} />
        ) : loader ? (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Circles color="#dfc8db" height={80} width={80} />
          </Box>
        ) : (
          <DefaultTermOfUse />
        )
      ) : (
        <DefaultTermOfUse />
      )}
    </div>
  );
};

export default TermOfUse;
